import { render, staticRenderFns } from "./UidTokenLoginV3.vue?vue&type=template&id=1d1c07ca&scoped=true&"
import script from "./UidTokenLoginV3.vue?vue&type=script&lang=js&"
export * from "./UidTokenLoginV3.vue?vue&type=script&lang=js&"
import style0 from "./UidTokenLoginV3.vue?vue&type=style&index=0&id=1d1c07ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c07ca",
  null
  
)

export default component.exports